/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strategy_Partner_Status_ActiveInputs */

const en_strategy_partner_status_active = /** @type {(inputs: Strategy_Partner_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const de_strategy_partner_status_active = /** @type {(inputs: Strategy_Partner_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

const pt_br2_strategy_partner_status_active = /** @type {(inputs: Strategy_Partner_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativa`)
};

const tr_strategy_partner_status_active = /** @type {(inputs: Strategy_Partner_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkin`)
};

const zh_cn2_strategy_partner_status_active = /** @type {(inputs: Strategy_Partner_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活跃`)
};

const zh_hk2_strategy_partner_status_active = /** @type {(inputs: Strategy_Partner_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`運作中`)
};

const ko_kr2_strategy_partner_status_active = /** @type {(inputs: Strategy_Partner_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`활성`)
};

const ru_ru2_strategy_partner_status_active = /** @type {(inputs: Strategy_Partner_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активна`)
};

const es_419_strategy_partner_status_active = /** @type {(inputs: Strategy_Partner_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activa`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Strategy_Partner_Status_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const strategy_partner_status_active = /** @type {((inputs?: Strategy_Partner_Status_ActiveInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strategy_Partner_Status_ActiveInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_strategy_partner_status_active(inputs)
	if (locale === "de") return de_strategy_partner_status_active(inputs)
	if (locale === "pt-BR") return pt_br2_strategy_partner_status_active(inputs)
	if (locale === "tr") return tr_strategy_partner_status_active(inputs)
	if (locale === "zh-CN") return zh_cn2_strategy_partner_status_active(inputs)
	if (locale === "zh-HK") return zh_hk2_strategy_partner_status_active(inputs)
	if (locale === "ko-KR") return ko_kr2_strategy_partner_status_active(inputs)
	if (locale === "ru-RU") return ru_ru2_strategy_partner_status_active(inputs)
	return es_419_strategy_partner_status_active(inputs)
});